module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-common', {
    attrs: {
      "type": "normal",
      "showAppTopLink": _vm.isSharePage,
      "showAppBotLink": _vm.isSharePage,
      "detail": _vm.data
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "wrap"
  }, [(_vm.data.type === 'video') ? _c('div', {
    ref: "videoWrap"
  }) : _vm._e(), _vm._v(" "), (_vm.data.type === 'video') ? _c('p', {
    staticClass: "video-wrap"
  }, [_c('video', {
    attrs: {
      "src": _vm.videoUrl,
      "poster": _vm.poster,
      "webkit-playsinline": "true",
      "playsinline": "true",
      "x5-playsinline": "true",
      "x-webkit-airplay": "allow",
      "controlsList": "nodownload"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "content-button"
  })]) : (_vm.data.type === 'audio' && _vm.isSharePage) ? _c('audioBar', {
    attrs: {
      "src": _vm.audioUrl,
      "totalTimes": _vm.totalTimes
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "essay"
  }, [(_vm.data.introTitle) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.introTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.title) ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.subTitle) ? _c('div', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.data.subTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.params.type === 'normal') ? [(_vm.data.categoryInfo && _vm.data.categoryInfo.parentId > 1) ? [_c('div', {
    staticClass: "category-info flex-default"
  }, [_c('div', {
    staticClass: "flex flex-cross-center"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.data.categoryInfo.image,
      "alt": "",
      "onerror": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h5', [_vm._v(_vm._s(_vm.data.categoryInfo.name))]), _vm._v(" "), _c('div', {
    staticClass: "date mult_line_ellipsis"
  }, [_vm._v(_vm._s(_vm.data.categoryInfo.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "date-wrap flex flex-cross-center"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.date))])])] : _c('div', {
    staticClass: "date-wrap flex flex-cross-center"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.date) + " " + _vm._s(_vm.source) + " " + _vm._s(_vm.data.authors))])])] : _vm._e(), _vm._v(" "), (_vm.data.sysCode === 'gov') ? [(_vm.data.orgInfo) ? [_c('div', {
    staticClass: "gov-info flex-default"
  }, [_c('div', {
    staticClass: "flex flex-cross-center",
    on: {
      "click": _vm.goGov
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.data.orgInfo.logo,
      "alt": "",
      "onerror": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h5', [_c('div', {
    staticClass: "line_ellipsis"
  }, [_vm._v(_vm._s(_vm.data.orgInfo.name))]), _c('span', {
    staticClass: "title-icon"
  }, [_vm._v("锦观号")])]), _vm._v(" "), _c('div', {
    staticClass: "date  mult_line_ellipsis"
  }, [_vm._v(_vm._s(_vm.data.orgInfo.introduction))])])]), _vm._v(" "), (!_vm.isSharePage && (_vm.isFollow === 1 || _vm.isFollow === 0)) ? _c('div', {
    class: ['follow-btn', _vm.isFollow ? 'no' : ''],
    on: {
      "click": _vm.setFollow
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.isFollow ? '已订阅' : '+订阅') + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "date-wrap flex flex-cross-center"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.date) + " " + _vm._s(_vm.source) + " " + _vm._s(_vm.data.authors))])])] : _c('div', {
    staticClass: "date-wrap flex flex-cross-center"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.date) + " " + _vm._s(_vm.source) + " " + _vm._s(_vm.data.authors))])])] : _vm._e(), _vm._v(" "), (_vm.$route.params.type === 'paper') ? [_c('div', {
    staticClass: "date-wrap flex flex-cross-center"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.date) + " " + _vm._s(_vm.source) + " " + _vm._s(_vm.data.authors))])])] : _vm._e()], 2), _vm._v(" "), (_vm.$route.params.type === 'paper') ? _c('ul', {
    staticClass: "images"
  }, _vm._l((_vm.data.imgall), function(item) {
    return _c('li', [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.imgUrl),
        expression: "item.imgUrl"
      }],
      attrs: {
        "alt": ""
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "content",
    class: ['content', !_vm.isSharePage ? 'font-size-' + _vm.fontSizeNum : 'font-size-4'],
    domProps: {
      "innerHTML": _vm._s(_vm.data.content ? _vm.data.content : '')
    }
  }), _vm._v(" "), (_vm.data.hasVote) ? _c('PageVote', {
    attrs: {
      "voteObj": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-footer"
  }), _vm._v(" "), _c('ul', {
    staticClass: "article-desc"
  }, [_c('li', [_vm._v("未经授权，严禁转载")]), _vm._v(" "), _c('li', [_vm._v("联系电话：028-86751128")])]), _vm._v(" "), (_vm.isSharePage && (_vm.$route.params.type === 'paper' || _vm.$route.params.type === 'normal' || _vm.data.sysCode === 'gov')) ? _c('div', {
    class: [_vm.isLike ? 'active-good uuidLikes flex flex-cross-center' : 'uuidLikes like flex flex-cross-center'],
    on: {
      "click": _vm.uuid
    }
  }, [_c('i', {
    class: [_vm.isLike ? 'active-good' : 'good']
  }), _vm._v(" "), _c('span', {
    class: [_vm.isLike ? 'active-num' : 'num']
  }, [_vm._v(_vm._s(_vm.likes <= 0 ? '赞' : _vm.getLikesCount(_vm.likes)))])]) : _vm._e(), _vm._v(" "), (_vm.relvantNewsData.length > 0) ? _c('div', {
    staticClass: "relevant-news"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    大家都在看\n                ")]), _vm._v(" "), _c('list', {
    attrs: {
      "relvantNewsData": _vm.relvantNewsData
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.comments !== null) ? _c('div', {
    staticClass: "comment"
  }, [(_vm.comments.length > 0) ? _c('div', {
    staticClass: "title"
  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v("热门评论")])]) : _vm._e(), _vm._v(" "), (_vm.comments.length > 0) ? _c('div', [_c('ul', _vm._l((_vm.comments), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.addComment(item)
        }
      }
    }, [_c('header', {
      staticClass: "flex flex-cross-center flex-main-justify"
    }, [_c('div', {
      staticClass: "flex flex-cross-center"
    }, [_c('div', {
      staticClass: "avatar",
      style: ({
        backgroundImage: ("url(" + (item.userIcon?item.userIcon:_vm.icon) + ")")
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "info-area"
    }, [_c('div', {
      staticClass: "name ellipsis"
    }, [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('div', {
      staticClass: "time ellipsis"
    }, [_vm._v(_vm._s(_vm.getTime(item.date)))])])]), _vm._v(" "), _c('div', {
      staticClass: "like flex flex-cross-center",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setActiveLike(item)
        }
      }
    }, [_c('span', {
      class: [item.isLike ? 'active-num' : 'num']
    }, [_vm._v(_vm._s(_vm.getLikesCount(item.likes + '')))]), _vm._v(" "), _c('i', {
      class: [item.isLike ? 'active-good' : 'good']
    })])]), _vm._v(" "), _c('section', [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })]), _vm._v(" "), (item.parent) ? _c('div', {
      staticClass: "origin"
    }, [_c('div', {
      staticClass: "origin-info flex flex-cross-center flex-main-justify"
    }, [_c('div', {
      staticClass: "origin-name"
    }, [_vm._v(_vm._s(item.parent.username))])]), _vm._v(" "), _c('div', {
      staticClass: "origin-content"
    }, [_vm._v("\n                                    " + _vm._s(item.parent.content) + "\n                                ")])]) : _vm._e()])
  }), 0), _vm._v(" "), (!_vm.isSharePage) ? _c('div', {
    staticClass: "check-all",
    on: {
      "click": function($event) {
        return _vm.appPostMessage('checkAllComment')
      }
    }
  }, [_vm._v("查看全部评论 "), _c('i')]) : _vm._e()]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (_vm.showLargeImage) ? _c('div', {
    staticClass: "largeSwiper"
  }, [_c('div', {
    staticClass: "viewSwiper",
    on: {
      "click": _vm.closeLargeImage,
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper "
  }, _vm._l((_vm.newImages), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide swiper-zoom-container"
    }, [_c('img', {
      attrs: {
        "src": item
      }
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eb72ad90!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-detail.vue
// module id = 871
// module chunks = 2